import {
  DocumentTab,
  TimeSeriesHistoryItem,
} from 'features/knowledgeDocumentViewer/types'

/**
 * The name a doc-viewer time-series tab currently shows. Used to pre-fill the
 * chart save-name prompt so the default matches the tab. A manual rename
 * (`customLabel`) wins over the history-item label, mirroring how the tab bar
 * derives its display label.
 */
export const timeSeriesTabDefaultName = (
  tab: Pick<DocumentTab, 'customLabel'>,
  item: Pick<TimeSeriesHistoryItem, 'label'>
): string => tab.customLabel ?? item.label

/**
 * The label to apply to a tab (and record in recents) after a chart save. The
 * saved chart name is authoritative; a blank name falls back to a placeholder
 * so tabs and recents are never nameless.
 */
export const chartSaveTabLabel = (savedName: string): string =>
  savedName.trim() || 'Untitled Chart'
